import { SxProps, Theme } from '@mui/material';

export const AccountFavoriteListFrameSX: SxProps<Theme> = () => ({
	display: 'flex',
	flexWrap: 'wrap',
	gap: '10px',
	marginTop: 'var(--spacing-5)',
	justifyContent: {
		xs: 'space-between',
		sm: 'flex-start',
	},
});

export const AccountFavoriteListPaperSX: SxProps<Theme> = {
	marginTop: 4,
};

export const AccountFavoriteItemSX: SxProps<Theme> = {
	minWidth: {
		xs: 'calc(51% - 10px)',
		sm: 'calc(25% - 10px)',
		md: 'auto',
	},
	maxWidth: {
		xs: 'calc(51% - 10px)',
		sm: 'calc(25% - 10px)',
	},
};
